import { useTranslation } from "react-i18next";
import {
  InfoContent,
  InfoHeader,
  InfoTitle
} from "../../../../../components/atoms/InfoCard";
import "./KpiCard.css";

export function KpiCard({ title, metricas }) {
  const { t } = useTranslation();

  return (
    <section className="kpi-card">
      <InfoHeader style={{ paddingBlockEnd: ".5rem" }}>
        <InfoTitle className="kpi-title">{t(title)}</InfoTitle>
      </InfoHeader>
      <InfoContent style={{ paddingInline: ".5rem" }}>
        <section className="kpi-section-content">
          {metricas?.map((metrica, i) => {
            return (
              <section
                key={i}
                className="kpi-item-content">
                <span className="kpi-item-value">{metrica?.value}</span>
                <span className="kpi-item-label">{t(metrica?.label)}</span>
              </section>
            );
          })}
        </section>
      </InfoContent>
    </section>
  );
}
